import React from 'react';
import { ArrowRight } from 'lucide-react';
interface PrimaryCTAProps {
  className?: string;
}
export function PrimaryCTA({
  className = ''
}: PrimaryCTAProps) {
  return <a href="#" className={`
        group inline-flex items-center justify-center gap-2 
        bg-blue-600 hover:bg-blue-700 text-white 
        px-8 py-4 rounded-lg font-semibold text-base
        transition-all duration-200 shadow-md hover:shadow-lg
        w-full sm:w-auto min-h-[48px]
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        ${className}
      `} data-id="element-108">
      <span data-id="element-109">Try Chime — 30-Day Money-Back Guarantee</span>
      <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-110" />
    </a>;
}